import { render, staticRenderFns } from "./LetterTemplateSettings.vue?vue&type=template&id=7b46dc67&scoped=true"
import script from "./LetterTemplateSettings.vue?vue&type=script&lang=js"
export * from "./LetterTemplateSettings.vue?vue&type=script&lang=js"
import style0 from "./LetterTemplateSettings.vue?vue&type=style&index=0&id=7b46dc67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b46dc67",
  null
  
)

export default component.exports